module.exports = __webpack_public_path__ + "static/media/5DPO1.82dbc505.jpg";